import useCountdown from '@util/hooks/useCountdown';
import type { ProductLight } from 'models/product';

export const ListProductAuctionCountdown = ({
  product,
}: {
  product: ProductLight;
}) => {
  const isStarted = product.start_time! < Date.now();
  const timeRemaining = useCountdown(
    product.start_time!,
    product.end_time!,
    isStarted ? 'end' : 'start'
  );
  return (
    <div className="mt-4 flex w-full items-center gap-[0.4rem] ">
      <div className="flex w-full items-center justify-center gap-[0.8rem] rounded-[1.5rem]">
        <span
          suppressHydrationWarning
          className={`w-full font-medium ${
            isStarted ? 'text-brand-green' : 'text-brand-secondary'
          }`}
        >
          {isStarted ? 'Ends in ' : 'Starts in '}
          {timeRemaining.days > 0 && `${timeRemaining.days}d `}
          {timeRemaining.hours}h {timeRemaining.minutes}m{' '}
          {timeRemaining.seconds}s
        </span>
      </div>
    </div>
  );
};
